import { boolean, object, type ParserResult } from '@/common/data-parsers'

export const TrackingMessagesSettings = object({
  send_emails: boolean(),
  send_sms: boolean(),
})
export type TrackingMessagesSettings = ParserResult<typeof TrackingMessagesSettings>
